import { render, staticRenderFns } from "./ODIComponent.vue?vue&type=template&id=3b059aa4&scoped=true"
import script from "./ODIComponent.vue?vue&type=script&lang=js"
export * from "./ODIComponent.vue?vue&type=script&lang=js"
import style0 from "./ODIComponent.vue?vue&type=style&index=0&id=3b059aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b059aa4",
  null
  
)

export default component.exports